import React from 'react';
import { useHistory } from 'react-router';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

const classes = {
  appPar: {
    zIndex: '999',
  },
  welcome: {
    marginTop: '4px',
    marginRight: '30px',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  logoContainer: {
    cursor: 'pointer',
  },
};

const DashboardNavBar = () => {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem('lhcfToken');
    history.push('/login');
  };

  return (
    <AppBar position="fixed" sx={classes.appPar}>
      <Toolbar sx={classes.toolbar}>
        <div
          style={classes.logoContainer}
          onClick={() => history.push('/dashboard')}
        >
          <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
            LHCF DASHBOARD
          </Typography>
        </div>
        <div style={{ display: 'flex' }}>
          <Typography variant="subtitle1" component="div" sx={classes.welcome}>
            Welcome, Admin
          </Typography>
          <Button variant="outlined" color="inherit" onClick={handleLogout}>
            Log Out
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavBar;
